import React, { PropTypes } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { addTitleResultShape } from '@bibliocommons/bc-prop-types';
import { AddTitle } from '../../../components/shared/AddTitle';
import { getAddTitleResult } from '../../../selectors/SearchSelector';
import SearchActions from '../../../actions/SearchActions';
import AvailabilityDetailActions from '../../../actions/AvailabilityDetailActions';

export class AddTitleContainer extends BcReactComponent {
  render() {
    const { addTitleResult, searchActions, availabilityDetailActions, isUpdatingResultItem, isWrappedInForm } = this.props;
    return (
      <div>
        <AddTitle
          isUpdatingResultItem={isUpdatingResultItem}
          searchActions={searchActions}
          availabilityDetailActions={availabilityDetailActions}
          searchQuery={addTitleResult.get('searchQuery')}
          pagination={addTitleResult.get('pagination')}
          zeroResults={addTitleResult.get('zeroResults')}
          results={addTitleResult.get('items')}
          isFetching={addTitleResult.get('isFetching')}
          handleClose={this.props.handleClose}
          renderAddOn={this.props.renderAddOn}
          addRowClassNames={this.props.addRowClassNames}
          isWrappedInForm={isWrappedInForm} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  addTitleResult: getAddTitleResult(state)
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch),
  availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch)
});

AddTitleContainer.propTypes = {
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  addTitleResult: addTitleResultShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  addRowClassNames: PropTypes.func,
  renderAddOn: PropTypes.func,
  isUpdatingResultItem: PropTypes.bool,
  isWrappedInForm: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTitleContainer);




// WEBPACK FOOTER //
// ./app/containers/shared/AddTitle/AddTitleContainer.jsx